import React from 'react';

interface PrivacyPolicyProps {
    className?: string;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ className = '' }) => {
    return (
        <div className={`text-sm text-gray-700 leading-relaxed ${className}`}>
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-gray-900 mb-2">허기(huggy) 모바일 어플리케이션</h2>
                <h3 className="text-lg font-semibold text-gray-800">개인정보 및 민감정보 처리방침</h3>
            </div>

            <div className="space-y-4">
                <p className="text-gray-600">
                    주식회사 돌봄드림(이하 "회사")는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                </p>
                <p className="text-gray-600">○ 이 개인정보처리방침은 2026년 1월 1일부터 적용됩니다.</p>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제1조(개인정보의 처리 목적)</h4>
                    <p className="mb-2">
                        허기(Huggy)는 노인복지용구 배회감지기 목적의 위치기반 안전 확인 서비스를 제공하기 위해 다음의 목적 범위에서 개인정보를 처리합니다. 처리 목적 이외의 용도로 이용되지 않으며, 목적이 변경되는 경우 「개인정보 보호법」 제18조에 따라 필요한 조치를 이행합니다.
                    </p>
                    <ol className="list-decimal list-inside space-y-2 ml-4">
                        <li>
                            <strong>회원가입 및 계정 관리</strong>
                            <p className="ml-6">회원 가입 의사 확인, 본인 식별·인증, 회원자격 유지·관리, 서비스 운영 고지·통지</p>
                        </li>
                        <li>
                            <strong>서비스 제공 및 운영(배회감지 중심)</strong>
                            <p className="ml-6">안전구역(지오펜스) 설정 및 이탈/복귀(배회 의심) 이벤트 생성·표시</p>
                            <p className="ml-6">위치 기반 이벤트 확인, 안전 확인 및 대응 지원</p>
                            <p className="ml-6">SOS, 낙상 감지 등 안전 관련 이벤트 제공 및 이력 관리</p>
                        </li>
                        <li>
                            <strong>알림 제공(신규 기능 포함)</strong>
                            <p className="ml-6">푸시/앱 내 배너 알림 제공</p>
                            <p className="ml-6">정보주체 또는 보호자에게 문자 알림(SMS) 제공(서비스 설정 및 동의에 따라)</p>
                        </li>
                        <li>
                            <strong>고객문의/민원 처리</strong>
                            <p className="ml-6">문의 응대, 고충 처리, 분쟁 대응 및 서비스 품질 개선</p>
                        </li>
                        <li>
                            <strong>마케팅 및 광고(해당 시)</strong>
                            <p className="ml-6">신규 서비스(제품) 개발, 맞춤 서비스 제공, 안내·이벤트 제공(별도 동의가 필요한 경우 동의를 받습니다)</p>
                        </li>
                    </ol>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제2조(개인정보의 처리 및 보유 기간)</h4>
                    <p className="mb-2">회사는 법령에 따른 보유·이용기간 또는 정보주체로부터 동의 받은 기간 내에서 개인정보를 처리·보유합니다.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>회원 계정 정보(이메일/비밀번호 등): 회원 탈퇴 시까지<br />
                            <span className="ml-6 text-sm">단, 관계 법령에 따라 보관이 필요한 경우 해당 법령에서 정한 기간 동안 보관</span>
                        </li>
                        <li>서비스 이용 기록(이벤트 이력, 접속기록 등): 서비스 목적 달성 또는 분쟁 대응을 위한 합리적 기간 내 보관 후 파기</li>
                        <li>개인위치정보 및 위치기반 이벤트 정보: 서비스 제공 목적 달성 시 지체 없이 파기<br />
                            <span className="ml-6 text-sm">단, 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 따라 개인위치정보 수집·이용·제공사실 확인자료는 6개월 이상 보관합니다.</span>
                        </li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제3조(처리하는 개인정보의 항목)</h4>
                    <p className="mb-2">회사는 서비스 제공을 위해 다음 항목을 처리합니다.</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                        <li>
                            <strong>회원가입 및 계정 관리(필수)</strong>
                            <p className="ml-6">이메일, 비밀번호</p>
                        </li>
                        <li>
                            <strong>서비스 운영/알림 제공(선택 또는 서비스 설정에 따라 처리)</strong>
                            <p className="ml-6">이름, 전화번호(문자 알림 수신자 등록 시 포함)</p>
                            <p className="ml-6">푸시 알림 토큰, 단말 식별자/OS 정보(알림 및 안정적 서비스 제공 목적)</p>
                        </li>
                        <li>
                            <strong>개인위치정보(배회감지 제공을 위한 핵심 정보)</strong>
                            <p className="ml-6">현재 위치, 안전구역 이탈/복귀 시점의 위치, 이동 경로(서비스 설정 및 동의 범위 내)</p>
                        </li>
                        <li>
                            <strong>민감정보(해당 시)</strong>
                            <p className="ml-6">서비스가 전용 디바이스와 연동되어 생체신호/안전 이벤트를 제공하는 경우, 낙상 감지 등 안전 관련 데이터가 처리될 수 있습니다.</p>
                            <p className="ml-6">회사는 법령이 요구하는 경우 별도 동의 등 적법한 절차에 따라 민감정보를 처리합니다.</p>
                        </li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제4조(개인정보의 파기절차 및 파기방법)</h4>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>회사는 개인위치정보의 수집·이용 또는 제공목적을 달성한 때에는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라 확인자료를 제외한 개인위치정보를 즉시 파기합니다.</li>
                        <li>확인자료(수집·이용·제공사실 확인자료)는 법령에 따라 6개월 이상 보관 후 파기합니다.</li>
                        <li>파기 시 복구 또는 재생을 방지하기 위한 조치를 취하며, 전자적 파일 형태는 복구 불가능한 방식으로 삭제합니다.</li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제5조(개인정보의 제3자 제공)</h4>
                    <p className="mb-2">회사는 원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 다만 다음의 경우는 예외로 합니다.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>정보주체가 사전에 동의한 경우<br />
                            <span className="ml-6 text-sm">예: 배회감지 목적의 알림/이벤트 확인을 위해, 정보주체가 지정한 보호자/요양기관 계정에 위치기반 이벤트 정보가 공유되는 경우</span>
                        </li>
                        <li>법령에 근거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 요청이 있는 경우</li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제6조(개인정보 처리의 위탁)</h4>
                    <p className="mb-2">회사는 원활한 서비스 제공을 위해 개인정보 처리업무를 위탁할 수 있으며, 위탁 시 관련 법령에 따라 안전하게 관리·감독합니다.</p>
                    <p className="ml-4">예: 문자 알림(SMS) 발송 대행, 클라우드/서버 운영, 고객지원 시스템 등</p>
                    <p className="ml-4">위탁사/위탁업무 내용은 계약 또는 변경 시 서비스 내 공지/방침을 통해 안내합니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제7조(정보주체와 법정대리인의 권리·의무 및 행사방법)</h4>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>정보주체는 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</li>
                        <li>권리 행사는 서면, 전자우편, FAX 등을 통해 할 수 있으며 회사는 지체 없이 조치합니다.</li>
                        <li>대리인을 통한 행사 시 관련 법령에서 정한 위임장을 제출할 수 있습니다.</li>
                        <li>법령에 따라 열람·처리정지 등이 제한될 수 있습니다.</li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제8조(개인정보의 안전성 확보조치)</h4>
                    <p className="mb-2">회사는 개인정보의 안전성 확보를 위해 다음 조치를 시행합니다.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>내부관리계획 수립 및 시행</li>
                        <li>개인정보 취급자 최소화 및 교육</li>
                        <li>접근권한 관리, 접속기록 보관 및 점검, 암호화 등 기술적 보호조치</li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제9조(자동수집 장치의 설치·운영 및 거부)</h4>
                    <p>회사는 이용정보를 저장하고 수시로 불러오는 쿠키(cookie)를 사용하지 않습니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제10조(행태정보의 수집·이용·제공 및 거부)</h4>
                    <p>회사는 온라인 맞춤형 광고 등을 위한 행태정보를 수집·이용·제공하지 않습니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제11조(추가적인 이용·제공 판단기준)</h4>
                    <p className="mb-2">회사는 「개인정보 보호법」 제15조제3항 및 제17조제4항에 따라 정보주체의 동의 없이 개인정보를 추가 이용·제공할 수 있는 경우, 시행령의 판단기준을 고려합니다.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>당초 수집 목적과의 관련성</li>
                        <li>예측 가능성</li>
                        <li>정보주체 이익의 부당 침해 여부</li>
                        <li>가명처리 또는 암호화 등 안전성 조치 여부</li>
                    </ul>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제12조(가명정보 처리)</h4>
                    <p>회사는 현재 개인정보를 가명처리하여 사용하지 않습니다. 향후 가명정보를 처리하는 경우 관련 사항을 안내합니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제13조(개인정보 보호책임자)</h4>
                    <p className="mb-2">회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 정보주체의 불만처리 및 피해구제를 위해 아래와 같이 개인정보 보호책임자를 지정합니다.</p>
                    <div className="ml-4 space-y-2">
                        <div>
                            <p className="font-semibold">개인정보 보호책임자</p>
                            <p>성명: 김지훈</p>
                            <p>부서/직위: (주)돌봄드림 / 대표이사</p>
                            <p>전화: 070-4452-5300</p>
                            <p>이메일: expo@dolbomdream.com</p>
                        </div>
                        <div>
                            <p className="font-semibold">개인정보 보호 담당부서</p>
                            <p>부서명: 기술개발팀</p>
                            <p>담당자: 김석현</p>
                            <p>전화: 070-4452-5300</p>
                            <p>이메일: bruno@dolbomdream</p>
                        </div>
                    </div>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제14조(정보주체의 권익침해에 대한 구제방법)</h4>
                    <p className="mb-2">정보주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)</li>
                        <li>개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
                        <li>대검찰청 : (국번없이) 1301 (www.spo.go.kr)</li>
                        <li>경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)</li>
                    </ul>
                    <p className="mt-2">
                        또한 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 따른 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 「행정심판법」이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
                    </p>
                    <p className="ml-4 text-sm">※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제15조(영상정보처리기기 운영·관리에 관한 사항)</h4>
                    <p className="mb-2">허기(Huggy)는 현재 영상정보처리기기를 운영하지 않습니다.</p>
                    <p>향후 영상정보처리기기를 운영하는 경우, 관련 법령에 따라 설치 목적, 촬영 범위, 관리 책임자, 보관 기간 및 열람 절차 등 필요한 사항을 별도로 안내·공개하겠습니다.</p>
                </section>

                <section className="mt-6">
                    <h4 className="font-bold text-gray-900 mb-2">제16조(개인정보 처리방침 변경)</h4>
                    <p className="mb-2">이 개인정보 및 민감정보 처리방침은 [적용일: 2026년 1월 1일]부터 적용됩니다.</p>
                    <p>내용의 추가, 삭제 및 수정이 있을 경우, 회사는 변경 사항을 적용일 전에 서비스 내 공지(또는 별도 고지)하여 안내하겠습니다.</p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
